import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { HttpParams } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, last, map, tap } from 'rxjs/operators';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
}

const BASE_API_URL = '';

@Injectable({
  providedIn: 'root'
})
export class LocationDetailsService {
  constructor(private http: HttpClient) {

  }


  getLocationDetails(custId : any): Observable<any> {
    const get_url = BASE_API_URL + 'subscriber/getLocationDetail/' + custId;
    return this.http.get<any>(get_url,{ headers: httpOptions.headers}).pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }



  updateLocationDetails(location_details_data): Observable<any> {
    const post_url = BASE_API_URL + 'subscriber/updateLocationDetail';
    return this.http.post<any>(post_url,location_details_data,{ headers: httpOptions.headers}).pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }

}
